<template>
  <div
    :class="[
      'sj-checkbox',
      `sj-checkbox-size-${size}`,
      {
        disabled
      }
    ]"
    @click.stop="handleClick"
  >
    <!-- box根据theme决定结构 -->
    <div
      class="sj-checkbox-box"
      :class="[theme, { checked: value, indeterminate }]"
    >
      <template v-if="indeterminate">
        <span class="indeterminate-icon"></span>
      </template>
      <template v-else>
        <i class="comcom_check icon_com comcheckbox_check" v-if="value" />
      </template>
    </div>
    <!-- 仅在有label时显示label -->
    <div v-if="label" class="sj-checkbox-label">
      {{ label }}
    </div>
  </div>
</template>

<script>
/**
 * checkbox组件，替换浏览器原生checkbox
 */
import sizeMixin from "../../../utils/sizeMixin";

export default {
  name: "SjCheckbox",
  mixins: [sizeMixin],
  props: {
    label: String,
    value: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: "border",
      validator(v) {
        return ["border", "fill"].indexOf(v) !== -1;
      }
    },
    indeterminate: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit("input", !this.value);
        this.$emit("change", !this.value);
      }
    }
  }
};
</script>

<style scoped lang="less">
.sj-checkbox {
    cursor: pointer;

    &.disabled {
        cursor: not-allowed;
        .sj-checkbox-label{
            color: @color-light !important;
        }
        .sj-checkbox-box {
            border-color: @color-light !important;
            .comcheckbox_check{
                color: @color-light !important;
            }
            &.border{
                .indeterminate-icon {
                    background-color: @color-light !important;
                }
            }

            &.fill {
                background-color: transparent !important;
                &.checked {
                    background-color: @color-light !important;

                    .comcheckbox_check {
                        color: @color-antibg !important;
                    }
                }

                &.indeterminate {
                    background-color: @color-light !important;
                    border-color: @color-light !important;
                    .indeterminate-icon{
                        background-color: @color-antibg !important;
                    }
                }
            }
        }
    }

    display: flex;
    align-items: center;
    each(@sizes, {
        &.sj-checkbox-size-@{value} {
            .size(@value);

            .sj-checkbox-label {
                color: @color-dark;
                margin-left: 4px;
                flex-shrink: 0;
            }

            @size: "@{value}-size";
            @icon-size: if(@value = large or @value = middle, 20px, 16px);
            .sj-checkbox-box {
                height: @@size;
                width: @@size;
                box-sizing: border-box;
                border-radius: @base-border-radius;
                border: @base-border-width @base-border-style @color-gray-4;
                display: flex;
                align-items: center;
                justify-content: center;

                .comcheckbox_check {
                    color: @color-alert-success;
                    font-size: @icon-size;
                }


                &:hover {
                    border-color: @color-highlight;
                }

                &.fill {
                    &.checked {
                        background-color: @color-highlight;

                        .comcheckbox_check {
                            color: @color-antibg;
                        }
                    }

                    &:hover {
                        background-color: @color-productlight;
                    }

                    &.indeterminate {
                        background-color: @color-productlight;
                        border-color: @color-productlight;
                        .indeterminate-icon{
                            background-color: @color-highlight;
                            width: @icon-size;
                            height: @icon-size;
                        }
                        &:hover {
                            border-color: @color-highlight;
                        }
                    }
                }

                &.border {
                    .indeterminate-icon{
                        background-color: @color-alert-success;
                        width: @icon-size - 2;
                        height: 2px;
                        border-radius: 1px;
                    }
                }
            }
        }
    })

}
</style>
